import React, { useState, useEffect } from 'react';
import { css } from 'emotion';
import { isMobile, isMobileOnly, isTablet, isIPad13 } from 'react-device-detect';
import { LargeBusiness, htmlWidget } from '../../Constants';
import { white } from '../../utils/CssGlobalVariables';

function EirQuickLinksPanel(props) {
  const [qlpSpecs, setQlpSpecs] = useState(props.quickLinkPanelSpecs);
  const [panelType, setPanelType] = useState((qlpSpecs.quickLinkItems.length > 4 || qlpSpecs.panelType.toLowerCase() === 'bar') ? 'qlp-bar' : 'qlp-tile');
  const [liHovered, setLIHovered] = useState(false);

  const renderContent = (content) => {
    return { __html: content };
  }
  //to handle the hover effect on the icon, copy - 
  // here the tagName check is done as the mouseover may be triggered on the parent (a tag) or from the children (img, span tags)
  //the mouseover and mouseout are being called from the anchor element
  const useHover = () => {
    // const handleHover = (e) => {
    //   if (!isMobile) {
    //     (e.type == 'mouseover' || e.type == 'touchstart') ?
    //       (e.target.tagName == 'A') ?
    //         (
    //           e.target.querySelector('.default-icon').classList.add('d-none'),
    //           e.target.querySelector('.hover-icon').classList.remove('d-none'),
    //           e.target.querySelector('.default-font').classList.add('d-none'),
    //           e.target.querySelector('.hover-font').classList.remove('d-none'),
    //           e.target.parentNode.style.backgroundColor  = qlpSpecs.quickLinkItems[e.target.parentNode.id.match(/\d+/)[0]].bgHoverColor,
    //           e.target.style.backgroundColor = qlpSpecs.quickLinkItems[e.target.parentNode.id.match(/\d+/)[0]].bgHoverColor
    //         )
    //         :
    //         (
    //           e.target.parentNode.querySelector('.default-icon').classList.add('d-none'),
    //           e.target.parentNode.querySelector('.hover-icon').classList.remove('d-none'),
    //           e.target.parentNode.querySelector('.default-font').classList.add('d-none'),
    //           e.target.parentNode.querySelector('.hover-font').classList.remove('d-none'),
    //           e.target.parentNode.style.backgroundColor  = qlpSpecs.quickLinkItems[e.target.parentNode.id.match(/\d+/)[0]].bgHoverColor,
    //           e.target.style.backgroundColor = qlpSpecs.quickLinkItems[e.target.parentNode.id.match(/\d+/)[0]].bgHoverColor
    //         )
    //       :
    //       (e.target.tagName == 'A') ?
    //         (
    //           e.target.querySelector('.default-icon').classList.remove('d-none'),
    //           e.target.querySelector('.hover-icon').classList.add('d-none'),
    //           e.target.querySelector('.default-font').classList.remove('d-none'),
    //           e.target.querySelector('.hover-font').classList.add('d-none'),
    //           e.target.parentNode.style.backgroundColor  = qlpSpecs.quickLinkItems[e.target.parentNode.id.match(/\d+/)[0]].bgColor,
    //           e.target.style.backgroundColor = qlpSpecs.quickLinkItems[e.target.parentNode.id.match(/\d+/)[0]].bgColor
    //         )
    //         :
    //         (
    //           e.target.parentNode.querySelector('.default-icon').classList.remove('d-none'),
    //           e.target.parentNode.querySelector('.hover-icon').classList.add('d-none'),
    //           e.target.parentNode.querySelector('.default-font').classList.remove('d-none'),
    //           e.target.parentNode.querySelector('.hover-font').classList.add('d-none'),
    //           e.target.parentNode.style.backgroundColor  = qlpSpecs.quickLinkItems[e.target.parentNode.id.match(/\d+/)[0]].bgColor,
    //           e.target.style.backgroundColor = qlpSpecs.quickLinkItems[e.target.parentNode.id.match(/\d+/)[0]].bgColor
    //         )
    //   }
    // }
 
   const handleHover = (e) => {
  if (!isMobile) {

    const isHover = (e.type === 'mouseover' || e.type === 'touchstart');

    const link = e.currentTarget;
    const li = link.closest('li');
    const index = li.id.match(/\d+/)[0];

    const defaultIcon = link.querySelector('.default-icon');
    const hoverIcon = link.querySelector('.hover-icon');
    const defaultFont = link.querySelector('.default-font');
    const hoverFont = link.querySelector('.hover-font');

    if (isHover) {

      if (defaultIcon) defaultIcon.classList.add('d-none');
      if (defaultFont) defaultFont.classList.add('d-none');

      if (hoverIcon) hoverIcon.classList.remove('d-none');

      if (hoverFont) {
        hoverFont.classList.remove('d-none');
        hoverFont.style.setProperty(
          "color",
          qlpSpecs.quickLinkItems[index].fontHoverColor,
          "important"
        );
      }

      // ✅ THE FIX: apply background to <a>, not <li>
      link.setAttribute(
        "style",
        `background: ${qlpSpecs.quickLinkItems[index].bgHoverColor} !important;`
      );

    } else {

      if (defaultIcon) defaultIcon.classList.remove('d-none');
      if (defaultFont) defaultFont.classList.remove('d-none');

      if (hoverIcon) hoverIcon.classList.add('d-none');
      if (hoverFont) hoverFont.classList.add('d-none');

      // ✅ THE FIX: normal background on <a>
      link.setAttribute(
        "style",
        `background: ${qlpSpecs.quickLinkItems[index].bgColor} !important;`
      );
    }
  }
};
  
    return [handleHover]
  }
  //the useHover returns the handleHover fn and this is used below
  const [handleHover] = useHover();
  const [ipadPortrait, setIpadPortrait] = React.useState((window.innerWidth >= 768 && window.innerWidth <= 1024) ? true : false);
  const [isMobileSmall, setMobileSmall] = React.useState((window.innerWidth >= 320 && window.innerWidth <= 767) ? true : false);
  const [dimensions, setDimensions] = React.useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  const handleResize = () => {
    if (isMobile) {
      setDimensions({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }
    (window.innerWidth >= 768 && window.innerWidth <= 1024) ? setIpadPortrait(true) : setIpadPortrait(false);
  }

  useEffect(() => {
    let getParentReference = document.getElementById('qlp-ctr-' + qlpSpecs.QuickLinkOccurence);
    // const ipadPortrait = (window.innerWidth >= 768 && window.innerWidth <= 1023) ? true : false
    const ipadPro = (window.innerWidth >= 1024 && window.innerWidth <= 1396) ? true : false
    window.addEventListener('resize', handleResize, false);
    // Hide or show the carousel component based on the devices
    let showCarousel = props.quickLinkPanelSpecs.panelDisplay;
    let quickLinksPanel = getParentReference;
    switch (true) {
      //hide in both
      case (showCarousel == 'none'): {
        quickLinksPanel.classList.add('hidden')
        break;
      }
      // hide in desktop and show only in mobile
      case (!isMobileOnly && showCarousel == 'mobile-only'): {
        quickLinksPanel.classList.add('hidden')
        break;
      }
      // hide in mobile and show in desktop
      case (isMobileOnly && showCarousel == 'desktop-only'): {
        quickLinksPanel.classList.add('hidden')
        break;
      }
      default: {
        quickLinksPanel.classList.remove('hidden')
      }
    }


    //set the width of the link items based on the count of links - only for DT
    const barItemWidth = (getParentReference.querySelector('.links-holder').clientWidth / qlpSpecs.quickLinkItems.length) - 10;
    if (panelType === 'qlp-bar' && (!isMobileOnly || ((window.matchMedia('(orientation:landscape)').matches && (window.innerWidth > 768 && window.innerWidth < 1023))))) {
      for (var itemCnt = 0; itemCnt < getParentReference.querySelectorAll('.link-item').length; itemCnt++) {
        getParentReference.querySelectorAll('.link-item')[itemCnt].style.width = barItemWidth + 'px';
        if (getParentReference.querySelectorAll('.link-item').length < 3) {
          var addNowrap = css`white-space-nowrap`;
          getParentReference.querySelector('.links-holder').querySelectorAll('.link-item')[itemCnt].classList.add(addNowrap);
        }
      }
    }
    //Fix for when QLP *Bar* has 2-3 items and wraps when the text is more - 
    if (panelType === 'qlp-bar' && isMobileOnly) {
      for (var itemCnt = 0; itemCnt < getParentReference.querySelector('.links-holder').querySelectorAll('.link-item').length; itemCnt++) {
        if (getParentReference.querySelector('.links-holder').querySelectorAll('.link-item').length <= 3) {
          var addNowrap = css`width:auto !important;`;
          getParentReference.querySelector('.links-holder').querySelectorAll('.link-item')[itemCnt].classList.add(addNowrap)
        }
      }
    }

  //   let setBarBG = css`background:${qlpSpecs.barBG};background-image: linear-gradient(180deg, ${qlpSpecs.barGradient}, ${qlpSpecs.barBG == qlpSpecs.barGradient ? qlpSpecs.barGradient : 'transparent'});`
  //   let setBlend = css`background-color: #fff;background-blend-mode: multiply;`
  // for (let imgCnt = 0; imgCnt < getParentReference.querySelectorAll('.image-bg').length; imgCnt++) {
  //   getParentReference.querySelectorAll('.image-bg')[imgCnt].classList.add(setBlend);
  // }
  let setBarBG = css`
  background:${qlpSpecs.barBG};
  background-image: linear-gradient(
    180deg,
    ${qlpSpecs.barGradient},
    ${qlpSpecs.barBG == qlpSpecs.barGradient ? qlpSpecs.barGradient : 'transparent'}
  );
`;

// ✅ FIX: make image-bg transparent instead of white
let setBlend = css`
  background-color: transparent !important;
  background-blend-mode: normal !important;
`;

for (let imgCnt = 0; imgCnt < getParentReference.querySelectorAll('.image-bg').length; imgCnt++) {
  getParentReference.querySelectorAll('.image-bg')[imgCnt].classList.add(setBlend);
}


    let panelTopValue = qlpSpecs.panelPositionFromTop;
    if (isMobileOnly && ipadPro && parseInt(panelTopValue) < 0) panelTopValue = (parseInt(panelTopValue) + 35) + 'px';
    let panelFromTop = (!isMobileOnly && !ipadPortrait) ? css`margin-top: ${panelTopValue}` : css``;
    if (getParentReference.querySelector('.qlp-bar') != null) {
      // getParentReference.querySelector(".qlp-bar").classList.add(setBarBG);
      //below is to move the QLP to coverup the curved portion of the carousel image  --- *** only when QLP is included in the carousel page****
      (isMobileOnly && getParentReference.querySelector('.fullwidth-carousel-container') != null) ? getParentReference.querySelector('.qlp-bar').parentNode.classList.add('qlp-bar-mobile-only', setBarBG) : getParentReference.querySelector('.qlp-bar').classList.add(setBarBG);
    }
    getParentReference.classList.add(panelFromTop);

    // carousel-indicators - dots - postion the carousel indicators based on the position set for the Quicklinks panel
    let setIndicatorPosition = Math.abs(parseInt(qlpSpecs.panelPositionFromTop));
    if (isMobileOnly) {
      setIndicatorPosition = (panelType === 'qlp-bar') ? (window.innerWidth > 415 && window.innerWidth < 767) ? (window.matchMedia('(orientation:landscape)').matches) ? '0' : '45' : '25' : '25';
    } else if (ipadPro && isMobile) {
      setIndicatorPosition = '55';
    }
    let indicatorPosition = (ipadPortrait) ? css`bottom: -5px!important` : (parseInt(qlpSpecs.panelPositionFromTop) < 0) ? css`bottom: ${setIndicatorPosition}px!important` : css``;
    if (document.querySelector('.carousel-indicators') != null) {
      document.querySelector('.carousel-indicators').classList.add(indicatorPosition);
    }
    return () => window.removeEventListener('resize', handleResize);
  }, [dimensions]);

  const qlpClasses = LargeBusiness.isLBSite ?
    {
      qlpSqEdge: 'eir-lb-square-edge',
      root: 'quicklinks-panel lb-quicklinks-panel',
      qlpTileBackground: (item) => (css`
      background: ${item.bgColor} !important; 
      &:hover{
        background: ${!isMobile && !isTablet ? item.bgHoverColor + ' !important' : ''}; 
      }`)

    } :
    {
      qlpSqEdge: '',
      root: 'quicklinks-panel',
      qlpTileBackground: (item) => (css`
    background: ${item.bgColor} !important;
    backgroundImage: linear-gradient(180deg," + ${item.bgColor} + ", transparent)
    &:hover{
      background:${item.bgHoverColor} !important; 
    }`)
    };

  return (
    <div className={(isMobileSmall && panelType === 'qlp-bar') ? qlpClasses.root : `${qlpClasses.root} container`} id={'qlp-ctr-' + qlpSpecs.QuickLinkOccurence}>
      <div className={`${panelType} ${(panelType === 'qlp-bar') ? `${qlpClasses.qlpSqEdge}` : ''}`} >
        <div className={`homepage-modules-title ${htmlWidget}`} dangerouslySetInnerHTML={renderContent(qlpSpecs.PanelTitle)}></div>
          <ul className="links-holder text-center">
          {qlpSpecs.quickLinkItems.map((item, i) =>

            <li key={i} id={'qlp_' + i} tabIndex={0}
              className={`link-item ${(panelType === 'qlp-tile') ? `${qlpClasses.qlpSqEdge}  ${qlpClasses.qlpTileBackground(item)}` : ''}`}
              title={item.title}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();                 
                    const anchor = e.currentTarget.querySelector('a');
                    if (anchor) {
                      anchor.click();
                    }
                  }
                }}
            // style={(panelType === "qlp-tile") ? { background: item.bgHoverColor, backgroundImage: "linear-gradient(180deg," + item.bgColor + ", transparent)" } : {}}
            >
              <a id={'qlp_link_' + i} tabIndex={-1} className={(item.defaultIcon.endsWith('.jsp') && (panelType === 'qlp-tile')) ? 'link-href no-image-tile' : 'link-href'} style={{paddingTop: '0rem'}} href={item.linkTo} onMouseOver={handleHover} onMouseOut={handleHover} title={item.name} aria-label={item.ariaLabel || undefined}>
                {/* as the hover image takes few milliseconds to load, preloading it and hiding the same */}
                <span className="image-bg"></span>
                
                {/* Below conditions added when image/icon is optional for **Tiles only** - as the hover script are already built based on the 
                    classnames, adding an empty span with same classname when no icon and same for the hover icon  - 
                */}
                {
                  (item.defaultIcon.endsWith('.jsp') && (panelType === 'qlp-tile')) ?
                    (
                    // <span className={"tile-no-image-ctr "+(css` &:hover {background-color: #${item.bgHoverColor} !important; `)}>
                          <span
  className={
    "tile-no-image-ctr " +
    css`background: transparent !important; background-color: transparent !important;`
  }
>

                        <span className="default-icon"></span>
                        <span className="hover-icon d-none"></span>
                        {/* <span id={"qlp_def_label_" + i} className="link-name default-font" style={{ color: item.fontColor }}> */}
                        <span id={'qlp_def_label_' + i} className={'link-name default-font ' + (css`color: ${item.fontColor !== '' ? item.fontColor : white + '!important' } `)}>
                          {item.name}
                          {(item.subcopyForTileOnly.length > 0) &&
                            <span className="qlp-tile-subcopy">{item.subcopyForTileOnly}</span>
                          }
                        </span>
                        <span id={'qlp_def_hov_label_' + i} className="link-name hover-font d-none" style={(item.fontHoverColor === '') ? { color: (panelType === 'qlp-bar') ?  white + '!important' : item.bgHoverColor } : { color: item.fontHoverColor }}>
                          {item.name}
                          {item.subcopyForTileOnly.length > 0 &&
                            <span className="qlp-tile-subcopy">{item.subcopyForTileOnly}</span>
                          }
                        </span>
                      </span>
                    )
                    :
                    (
                    <span className={`tile-image-ctr ${panelType === 'qlp-tile' ?  'd-flex flex-row justify-content-center align-items-center h-100 ' + (css` &:hover {background-color: ${item.bgHoverColor} !important; `): ''}`}>
                        <img id={"qlp_def_img_" + i} className="link-icon default-icon" src={item.defaultIcon}  alt={item.altText ? item.altText :""}/>
                        <img id={"qlp_hov_img_" + i} className="link-icon hover-icon d-none" src={item.hoverIcon} alt={item.altText ? item.altText :""} />
                        <span id={"qlp_def_label_" + i} className="link-name default-font p-0" style={{ color: item.fontColor }}>{item.name}</span>
                        <span id={"qlp_def_hov_label_" + i} className="link-name hover-font d-none p-0" style={(item.fontHoverColor === "") ? { color: (panelType === "qlp-bar") ? white : item.bgHoverColor } : { color: item.fontHoverColor }}>{item.name}</span>
                    </span>
                    )
                }
              </a>
              {LargeBusiness.isLBSite && <span className="qlp-tile-gradient-border"></span>}
            </li>
          )}
          </ul>
        </div>
      </div>
  );
}
export default EirQuickLinksPanel;
